import { useState } from 'react';

import OnboardingSteps from './OnboardingSteps';
import { UserInfoFormValues } from './onboardingForm';
import { Dialog } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import NextBackButtonGroup from './NextBackButtonGroup';
import { signOut } from '@modules/supabase/supabase-config';

const initialValues: UserInfoFormValues = {
    firstName: '',
    lastName: '',
};

export default function OnboardingModal() {
    const [currentOnboardingStep, setCurrentOnboardingStep] = useState(0);
    const onNextClick = () => setCurrentOnboardingStep(currentOnboardingStep + 1);
    const formMethods = useForm<UserInfoFormValues>({
        defaultValues: initialValues,
    });

    // onPrevClick decrements the page by 1 unless we are already at page 0
    const onPrevClick = () => {
        const prevPage = Math.max(0, currentOnboardingStep - 1);
        setCurrentOnboardingStep(prevPage);
    };

    return (
        <FormProvider {...formMethods}>
            <form>
                <Dialog open={true} sx={{ '& .MuiDialog-paper': { padding: 4 } }}>
                    <OnboardingSteps step={currentOnboardingStep} />
                    <NextBackButtonGroup
                        step={currentOnboardingStep}
                        // Go back one page
                        onClose={signOut}
                        onPrevClick={onPrevClick}
                        onNextClick={onNextClick}
                    />
                </Dialog>
            </form>
        </FormProvider>
    );
}
